<template>
  <AppHeader style="background:#ed2f2d!important" />
 <div class="container-xxl ">
    <!-- Hero -->
    <section class="hero" id="accueil" ref="hero">
      <div class="hero-content">
        <h1 class=" ff-t4 text-white">Mia</h1>
        <h1 class=" ff-t1 text-white sr-only">Le meilleur restaurant italien et Pizzeria à Grenoble</h1>  
        <div class="hero-buttons">
                 <router-link to="/contact" style="text-decoration: none" class="btn ffv btn-secondary">Réserver
            </router-link>
                 <router-link to="/carte" style="text-decoration: none" class="btn ffv btn-secondary">La Carte
            </router-link>
        </div>
      </div>
    </section>

    <!-- Menu -->
    <section class="menu-section" id="carte">
      <div class="container">
        <div class="menu-grid">
          <div class="menu-item " v-for="(item, i) in menuItems" :key="i" ref="menuItemsEls">
             <router-link to="/carte" style="text-decoration: none" class="">
            
            <div class="menu-image">
              <img :src="item.img" :alt="item.title" />

            </div>
            <h3 class="menu-title ff-t1 ">{{ item.title }}</h3>
            
            
          </router-link>
          </div>
        </div>

      </div>
    </section>
    <div class="basic-color ff-t3  mt-5 mb-2"> La carte</div>
   
         <router-link to="/carte" style="text-decoration: none" class=" btn btn-personalise ffv mb-2 ">Découvrir
            </router-link>

    <!-- About -->
    <section class="about-section" id="apropos">
      <div id="about" class="container-xxl py-5 rounded" itemscope itemtype="http://schema.org/AboutPage">
        <div class="container">
          <div class="row g-5 align-items-center">
            <div class="col-lg-6">
              <div class="row g-3">
                <div class="col-6 text-start">
                  <img class="img-fluid rounded w-100 wow animate__animated animate__zoomIn" data-wow-delay="0.1s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[1].url
                    " alt="À propos 1" itemprop="image" />
                </div>
                <div class="col-6 text-start">
                  <img class="img-fluid rounded w-75 wow animate__animated animate__zoomIn" data-wow-delay="0.3s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[0].url
                    " style="margin-top: 25%" alt="À propos 2" itemprop="image" />
                </div>
                <div class="col-6 text-end">
                  <img class="img-fluid rounded w-75 wow animate__animated animate__zoomIn" data-wow-delay="0.5s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[2].url
                    " alt="À propos 3" itemprop="image" />
                </div>
                <div class="col-6 text-start">
                  <img class="img-fluid rounded w-75 wow animate__animated animate__zoomIn" data-wow-delay="0.7s" :src="'https://admin.mia-restaurant.fr' +
                    proposData.images[3].url
                    " alt="À propos 4" itemprop="image" />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <h5 class="ff-t3 basic-color" itemprop="headline">
                À propos
              </h5>
              <h1 class="mb-4 ff-t3 basic-color" itemprop="name">
                {{ proposData.titre || "Bienvenue chez Mia" }}
              </h1>
              <p class="mb-4 ffv " itemprop="description">
                {{ proposTexteParsed.texte1 || texte1Secour }}
              </p>
              <p class="mb-4 ffv">
                {{ proposTexteParsed.texte2 || texte2Secour }}
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="avis" class="container-xxl py-5" style="background-color: #ea3531;">
      <div class="container">
        <div class="text-center wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
          <google-review />
        </div>
      </div>
    </section>
    <!-- Reviews -->
    <!-- <section class="reviews-section">
      <div class="container">
        <h2 class="reviews-title">Avis</h2>
        <div class="reviews-grid">
          <div class="review-card" v-for="i in 3" :key="i" ref="reviewCards">
            <div class="stars">
              <span class="star" v-for="n in 5" :key="n">★</span>
            </div>
            <p class="review-text">Excellent restaurant italien.</p>
          </div>
        </div>
      </div>
    </section> -->
    </div>
    <div
      style="width:100%; height: 65px;background-image: url('/img/01.svg'); background-repeat: repeat; background-size: 24px 24px; position: relative;">
      <div
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; transform: rotate(180deg); background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); pointer-events: none;">
      </div>
    </div>
    <!-- Footer -->
   

           <AppFooter />


 
</template>

<script>
import GoogleReview from "@/components/sections/GoogleReview.vue";
import AppFooter from "@/components/layout/Footer.vue"; 
import AppHeader from "@/components/layout/Header.vue"; 
export default {
  name: 'HomeView',
  components: {
    GoogleReview,
    AppHeader,
    AppFooter
  },
  data() {
    return {
      mobileMenuOpen: false,
      proposData: this.$store.state.propos,

      menuItems: [
        {
          title: 'PIZZA',
          img: new URL('../assets/img/pizzas.png', import.meta.url).href,
          description: "Le pizzas d'italien,<br> cremeux marron sarson<br> et merveilleuse."
        },
        {
          title: 'PASTA',
          img: new URL('../assets/img/pastas.png', import.meta.url).href,
          description: 'La Carte'
        },
        {
          title: 'DOLCI & AMORE',
          img:  new URL('../assets/img/dolce.png', import.meta.url).href,
          description: "La saense okampirect<br> cms morseon de cotone<br> la dolci & amore."
        }
      ]
    }
  },

  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false
    },

    openInstagram() {
      window.open('https://www.instagram.com/mia_grenoble/', '_blank')
    },

    ripple(e) {
      const button = e.currentTarget
      const ripple = document.createElement('span')
      const rect = button.getBoundingClientRect()
      const size = Math.max(rect.width, rect.height)
      ripple.style.width = ripple.style.height = size + 'px'
      ripple.style.left = e.clientX - rect.left - size / 2 + 'px'
      ripple.style.top = e.clientY - rect.top - size / 2 + 'px'
      ripple.className = 'ripple'
      button.appendChild(ripple)
      setTimeout(() => ripple.remove(), 600)
    },

    handleScroll() {
     

      if (this.$refs.hero) {
        this.$refs.hero.style.transform = `translateY(${window.pageYOffset * -0.5}px)`
      }
    },

    observeElements() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0)'
          }
        })
      }, { threshold: 0.1 })

        ;[...(this.$refs.menuItemsEls || []), ...(this.$refs.reviewCards || [])].forEach(el => {
          el.style.opacity = '0'
          el.style.transform = 'translateY(30px)'
          el.style.transition = 'opacity 0.6s ease, transform 0.6s ease'
          observer.observe(el)
        })
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.observeElements()
    console.log(this.proposData);
  },
  computed: {
    proposTexteParsed() {
      try {
        return JSON.parse(this.proposData?.texte || "{}");
      } catch (e) {
        console.warn("proposData.texte JSON invalide:", this.proposData?.texte);
        return {};
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
